import { render } from 'preact';

// Every font is SELF-HOSTED: these packages put the font files into the build, and the
// site serves them itself. The brief forbids externally hosted fonts — loading a font
// from Google hands each visitor's address to Google.
import '@fontsource/cormorant-garamond/400.css';
import '@fontsource/cormorant-garamond/400-italic.css';
import '@fontsource/cormorant-garamond/600.css';
import '@fontsource/lora/400.css';
import '@fontsource/lora/600.css';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

import './styles/classical.css';
import './styles/site.css';
import { App } from './App';
// Last, after every component's own stylesheet: the phone rules adjust them all.
import './styles/phone.css';

// The record in plain text that the server writes into every page for readers that do not run
// JavaScript (search engines, AI agents; server/srweb/facts.py). The app shows the same facts, so it goes.
document.getElementById('sr-facts')?.remove();
render(<App />, document.getElementById('app')!);
